import React, { useState } from 'react'

// Components
import FilterBar from './GridView/FilterBar'
import Body from './GridView/Body';

// prime react
import { BreadCrumb } from "primereact/breadcrumb";
import { useLocation } from 'react-router-dom';

const DocumentCategories = (props) => {

    const { id } = props;

    const location = useLocation();

    // states

    const [loading, setLoading] = useState(false);
    const [clientName, setClientName] = useState(location.state?.cbn ?? 'Document Categories');
    const [keyword, setKeyword] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeTabData, setActiveTabData] = useState(
        {
            underWritingTab: {
                activeTabIndex: 0,
                underWrittingHeaders: [
                    { field: "attachment_name", header: "Document Title" },
                    { field: "uploaded_by", header: "Uploaded By" },
                    { field: "updated_at", header: "Uploaded Date" },
                    { field: "attachment_type", header: "Document Type" },
                    { field: "preview", header: "Preview" },
                ],
            },
            invoicesTab: {
                activeTabIndex: 1,
                invoicesHeaders: [
                    { field: "attachment_name", header: "Document Title" },
                    { field: "invoice_no", header: "Invoice No" },
                    { field: "debtor_name", header: "Debtor Name" },
                    { field: "uploaded_by", header: "Uploaded By" },
                    { field: "updated_at", header: "Uploaded Date" },
                    { field: "preview", header: "Preview" },
                ],
            },
            collectionsTab: {
                activeTabIndex: 2,
                collectionsHeaders: [
                    { field: "attachment_name", header: "Document Title" },
                    { field: "collection_id", header: "Collection ID" },
                    { field: "collection_date", header: "Collection Date" },
                    { field: "uploaded_by", header: "Uploaded By" },
                    { field: "updated_at", header: "Uploaded Date" },
                    { field: "preview", header: "Preview" },
                ],
            }
        }

    )

    const [isRangeShow, setIsRangeShow] = useState(false);
    const [selectedDateFilter, setSelectedDateFilter] = useState("30days");
    const [dates2, setDates2] = useState(null);

    const items = [{ label: "Document", url: "/documents" }, { label: id ? "Edit Document Category" : clientName }];
    const home = { icon: "bi bi-file-earmark-word" };

    return (
        <div>
            <div>
                <BreadCrumb model={items} home={home} />
            </div>
            <FilterBar activeIndex={activeIndex} activeTabData={activeTabData} setActiveTabData={setActiveTabData} setActiveIndex={setActiveIndex}
                setKeyword={setKeyword} keyword={keyword} isRangeShow={isRangeShow} setIsRangeShow={setIsRangeShow} selectedDateFilter={selectedDateFilter} setSelectedDateFilter={setSelectedDateFilter}
                dates2={dates2} setDates2={setDates2} />

            <Body activeIndex={activeIndex} activeTabData={activeTabData} setActiveTabData={setActiveTabData} keyword={keyword} clientName={clientName} setClientName={setClientName}
                isRangeShow={isRangeShow} selectedDateFilter={selectedDateFilter} dates2={dates2} loading={loading} setLoading={setLoading} />
        </div>
    )
}

export default DocumentCategories;